import { Action } from '@ngrx/store';

import { EvaluationActionType } from './evaluation-action-type.enum';


export class SelectEvaluation implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.SelectEvaluation;

  constructor(public readonly payload: number) { }
}

export class SelectEvaluationCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.SelectEvaluationCompleted;

  constructor(public readonly payload: number) { }
}

export class SelectEvaluationFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.SelectEvaluationFailed;

  constructor(public readonly payload: string) { }
}
